import * as types from '../actions/types';

const initialState = {
    pgmList: [], 
    pgmDetail:[],
    success: false
}

export default function pgmReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.GET_PGM_LIST:
            return {
                ...state,
                pgmList: action.payload.data,
                success: true
            };
            case types.GET_PGM_DETAIL:
            return {
                ...state,
                pgmDetail: [...state.pgmDetail, action.payload.data.data],
                success: true
            }
        default:
            return state
    }
}